function OfferCard({ offer }) {
    return (
        <img className='w-[45%] rounded-xl' src={offer?.couponImage} alt={offer.couponName} />
    )
}

function OfferDisplay({ item }) {
    return (
        <div className='w-full flex flex-col gap-2'>
            <h1 className='text-[10px] leading-3 text-[#B0B0B0] px-2'>{item.name}</h1>

            <div className="px-2 flex flex-nowrap w-full gap-2">
                {item.offersList.map(offer => {
                    return (
                        <OfferCard 
                            key={offer.id} 
                            offer={offer} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default OfferDisplay;
